;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import type { init } from '@sentry/nextjs';

import pkg from './package.json';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

const BASE_CONFIG: Parameters<typeof init>[0] = {
  dsn: SENTRY_DSN,
  debug: false,
  release: pkg.version,
  // No `tracesSampleRate`: tracing/performance monitoring is off by design. The
  // tracing SDK code is tree-shaken out of the bundle via
  // `bundleSizeOptimizations.excludeTracing` in next.config.mjs, so Sentry is
  // used for error reporting only.
  //
  // Capture user IP addresses (and other default PII). SDK v10 stopped inferring
  // these unless opted in; we keep them for fraud/abuse triage. This was the
  // pre-v10 default behaviour.
  sendDefaultPii: true,
};

export default BASE_CONFIG;
